import styles from "./YuJaCheckbox.module.css";
import { Checkbox } from '@base-ui/react/checkbox';


export const YuJaCheckbox = ({
                                 checked = false,
                                 indeterminate=false,
                                 onChange,
                                 disabled = false,
                                 label = "",
                                 ariaLabel = "",
                                 size = 16,
                                 style,
                                 ...props
                             }) => {


    return (
        <label className={styles.Label} style={{...style}}>
            <Checkbox.Root
                {...props}
                checked={checked}
                disabled={disabled}
                indeterminate={indeterminate}
                className={styles.Checkbox}
                aria-label={ariaLabel}
                onCheckedChange={(checked, eDetails) => onChange(checked, eDetails.event)}
                style={{width: size, height: size}}
            >
                <Checkbox.Indicator className={styles.Indicator} keepMounted={true}>
                    <CheckIcon style={{width: size, height: size}} className={styles.CheckedIcon}/>
                    <span style={{width: size, height: size}} className={styles.IndeterminateIcon}/>
                </Checkbox.Indicator>
            </Checkbox.Root>
            {!!label && label}
        </label>
    );
}


function CheckIcon(props) {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M2 0.34668H14C14.9133 0.34668 15.6533 1.08669 15.6533 2V14C15.6533 14.9133 14.9133 15.6533 14 15.6533H2C1.08669 15.6533 0.34668 14.9133 0.34668 14V2C0.34668 1.08669 1.08669 0.34668 2 0.34668Z"
                fill="#0B6F85"/>
            <path
                d="M2 0.34668H14C14.9133 0.34668 15.6533 1.08669 15.6533 2V14C15.6533 14.9133 14.9133 15.6533 14 15.6533H2C1.08669 15.6533 0.34668 14.9133 0.34668 14V2C0.34668 1.08669 1.08669 0.34668 2 0.34668Z"
                stroke="#0B6F85" strokeWidth="0.692616"/>
            <path d="M12.7144 4.14941L6.11087 11.4127L2.80908 7.78121" stroke="white" strokeWidth="2"
                  strokeLinecap="round" strokeLinejoin="round"/>
        </svg>


    );
}